export var ToolCategories;
(function (ToolCategories) {
    ToolCategories["CALCULATE"] = "calculate";
    ToolCategories["CLEAN"] = "clean";
    ToolCategories["COMBINE"] = "combine";
    ToolCategories["DATA"] = "data";
    ToolCategories["LEARN"] = "learn";
    ToolCategories["ORGANIZE"] = "organize";
    ToolCategories["SPM"] = "sales_performance";
    ToolCategories["THE_BASICS"] = "the_basics";
    ToolCategories["PREDICT"] = "predict";
    ToolCategories["PREPARE"] = "prepare";
    ToolCategories["GROUP"] = "group";
    ToolCategories["COMPARE"] = "compare";
    ToolCategories["TEXT_TOOLS"] = "text_tools";
    ToolCategories["DATE_TOOLS"] = "date_tools";
    ToolCategories["COMPUTE"] = "compute";
    ToolCategories["UNDERSTAND"] = "understand";
    ToolCategories["CONNECT"] = "connect";
    ToolCategories["ENCODE"] = "encode";
    ToolCategories["SAMPLE_DATA"] = "sample_data";
    ToolCategories["OPTIMIZE"] = "optimize";
    ToolCategories["REUSABLE_LOGIC"] = "reusable_logic";
    // not shown in command modal
    ToolCategories["FORECAST"] = "forecast";
    ToolCategories["OUTLIER"] = "outlier";
    ToolCategories["TEXT_CLASSIFIER"] = "text_classifier";
    ToolCategories["CLASSIFIER"] = "classifier";
    ToolCategories["REGRESSOR"] = "regressor";
    ToolCategories["UNSEEN"] = "unseen";
})(ToolCategories || (ToolCategories = {}));
//# sourceMappingURL=toolCategories.js.map